import { createAppStore } from '@store/createAppStore';
import { produce } from 'solid-js/store';

import { getClaims } from './services';
import { ClaimsState } from './types';

const [claimsStore, setClaimsStore, resetClaimsStore] =
  createAppStore<ClaimsState>(
    {
      isLoading: true,
      isError: false,
      errorMessage: '',
      items: [],
      overlay: false,
    },
    'claimsStore',
  );

export const fetchClaims = async () => {
  try {
    setClaimsStore('isLoading', true);
    const resp = await getClaims();
    setClaimsStore(
      produce((draft: ClaimsState) => {
        // @ts-expect-error Type mismatch.
        draft.items = resp;
        draft.isLoading = false;
      }),
    );
  } catch (e) {
    setClaimsStore(
      produce((draft: ClaimsState) => {
        draft.isError = true;
        draft.errorMessage = 'Failed loading claims';
        draft.isLoading = false;
      }),
    );
  }
};

export { claimsStore, resetClaimsStore, setClaimsStore };
